"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M338.824 57.966v222.155H0v1581.29h225.882V506.117h112.942v222.268l406.814-335.21L338.824 57.967zm1355.407 448.15h225.882V280.122H1694.23v225.996zm-338.937 0h225.995V280.122h-225.995v225.996zm-338.823 0h225.882V280.122H1016.47v225.996zM677.76 957.882h1242.353V732H677.76v225.882zm0 451.765h1242.353v-225.995H677.76v225.995zm0 451.765h1242.353v-225.883H677.76v225.883z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveUpTop =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconMoveUpTop, _Component);

  function IconMoveUpTop() {
    (0, _classCallCheck2.default)(this, IconMoveUpTop);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconMoveUpTop).apply(this, arguments));
  }

  (0, _createClass2.default)(IconMoveUpTop, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconMoveUpTop",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconMoveUpTop.displayName = "IconMoveUpTop";
  return IconMoveUpTop;
}(_react.Component);

exports.default = IconMoveUpTop;
IconMoveUpTop.glyphName = 'move-up-top';
IconMoveUpTop.variant = 'Solid';
IconMoveUpTop.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);